import Vue from 'vue';
import Vuex from 'vuex';
import application from './modules/application';
import integrations from './modules/integrations';
import companies from './modules/companies';
import conversations from './modules/conversations';
import auth from './modules/auth';
import questionnaires from './modules/questionnaires';
import filingInstructions from './modules/filingInstructions';
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    application,
    integrations,
    auth,
    conversations,
    companies,
    questionnaires,
    filingInstructions,
  },
});
